export * from './__generated__/tenant-integrations.query.generated';
